import React, {useEffect, useState} from "react";
import {NAME_CONVENTION} from "../../../../configs/AppConfig";
import {updatePreferenceData} from "../../../../services/CommonService";
import {toast} from "react-toastify";
import Utils from "../../../../utils";
import {Lang} from "../../../../lang";

function FileOption(props) {

    const [isSyncAttachments, setIsSyncAttachments] = useState(0);
    const [syncCloud, setSyncCloud] = useState(0);
    const [referenceId, setReferenceId] = useState('');
    const [namingConvention, setNamingConvention] = useState(1);
    const [storageList, setStorageList] = useState([]);

    useEffect(function () {
        setIsSyncAttachments((props?.preferenceData.sync_cloud) ? parseInt(props?.preferenceData.sync_cloud) : 0);
        setSyncCloud((props?.preferenceData.default_cloud_storage) ? parseInt(props?.preferenceData.default_cloud_storage) : 0);
        setReferenceId((props?.preferenceData.default_reference_id) ? props?.preferenceData.default_reference_id : '');
        setNamingConvention((props?.preferenceData.default_naming_convention) ? parseInt(props?.preferenceData.default_naming_convention) : 1);

        setStorageList((props?.cloudStorage) ? props.cloudStorage : []);

    }, [props?.preferenceData, props?.cloudStorage]);

    const handleUpdateMessage = (e) => {
        e.preventDefault();

        props.setLoading(true);

        let updateList = [
            {slug: 'sync_cloud', value: (isSyncAttachments) ? 1 : 0},
            {slug: 'default_cloud_storage', value: syncCloud},
            {slug: 'default_reference_id', value: referenceId},
            {slug: 'default_naming_convention', value: namingConvention}
        ];

        updatePreferenceData({list: updateList})
            .then(response => {
                props.setLoading(false);
                toast.success(response.data.message);
            })
            .catch(err => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });

    };

    return (
        <div className="tab-pane setting-tab-pane" id="FileOption" role="tabpanel">

        <div className="setting-card">
      
          {/* CLOUD STORAGE TITLE */}
          <div className="setting-section-title">Cloud Storage</div>
      
          {/* SYNC CLOUD SWITCH */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">{Lang.preference_sync_cloud}</p>
              <p className="setting-text">{Lang.preference_sync_cloud_text}</p>
            </div>
      
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={isSyncAttachments}
                  onChange={(e) => setIsSyncAttachments(e.target.checked)}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* DEFAULT STORAGE SELECT */}
          <div className="setting-row">
            <div className="setting-col-full">
              <p className="setting-label-bold">{Lang.preference_default_storage}</p>
              <p className="setting-text">{Lang.preference_default_storage_text}</p>
      
              <select
                className="setting-select mt-2"
                value={syncCloud}
                onChange={(e) => setSyncCloud(e.target.value)}
              >
                {storageList.map((item, index) => (
                  <option key={index} value={item.id} disabled={item.is_disabled}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
      
          {/* NAMING CONVENTION TITLE */}
          <div className="setting-section-title mt-4">Naming Convention</div>
      
          {/* DEFAULT REF ID */}
          <div className="setting-row">
            <div className="setting-col-full">
              <p className="setting-label-bold">Default Reference ID</p>
              <p className="setting-text">
                Prepend / append your invite’s reference with the document name.
              </p>
      
              <input
                type="text"
                value={referenceId}
                onChange={(e) => setReferenceId(e.target.value)}
                className="setting-input mt-2"
                placeholder=""
              />
            </div>
          </div>
      
          {/* DEFAULT NAMING SELECT */}
          <div className="setting-row">
            <div className="setting-col-full">
              <p className="setting-label-bold">Default Naming Convention</p>
              <p className="setting-text">
                Please choose a format for your default file naming convention.
              </p>
      
              <select
                className="setting-select mt-2"
                value={namingConvention}
                onChange={(e) => setNamingConvention(e.target.value)}
              >
                {NAME_CONVENTION.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
      
          {/* BUTTON */}
          <div className="setting-btn-container">
            <button
              type="button"
              onClick={handleUpdateMessage}
              className="setting-btn-primary"
            >
              Update
            </button>
          </div>
        </div>
      </div>
      
    );
}

export default FileOption;